<template>
    <form @submit.prevent="handleSubmit(item)">
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Name</label>
            <input v-model="item.name" type="text" placeholder="the name of the item" required="true" id="_name"
                   class="form-control"/>
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
            <label for="_description" class="control-label">Description</label>
            <input v-model="item.description" type="text" placeholder="a description of the item" required="true"
                   id="_description" class="form-control"/>
            <span v-if="errors && errors.description" class="help-block" id="_description_helpBlock">{{ errors.description }}</span>
        </div>
        <div class="card bn-tabs">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li v-for="(value, key, index) in languages" class="nav-item">
                    <a class="nav-link" v-bind:class="{ active: index===0, show: index===0 }"
                       :id="'translation-tab-' + key" data-toggle="tab"
                       :href="'#translation-tab-content-' + key" role="tab" :aria-controls="index"
                       aria-selected="false">{{
                        value }}</a>
                </li>
            </ul>
            <div class="tab-content" id="translationTabContent">
                <div v-for="(value, key) in item.translations" class="tab-pane fade"
                     v-bind:class="{ active: key==='de', show: key==='de' }" :id="'translation-tab-content-' + key"
                     role="tabpanel" :aria-labelledby="'translation-tab-' + key">
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.description) }">
                        <label :for="'_translation_'+ key +'_template'" class="control-label">Template</label>
                        <textarea v-model="item.translations[key].template"
                                  placeholder="twig template"
                                  :id="'_translation_'+ key +'_template'" class="form-control" style="width:50%; float:left; height:300px;"></textarea>

                        <div class="tree form-control" style="margin-left: 5px; width:18%; float:left; height: 300px; overflow: auto;">
                            <ul :id="'tree_'+item.translations[key].locale" v-if="api_models['Organization-organization_organization-read']">
                                <li api-data-toggle="tooltip" :title="api_models['Organization-organization_organization-read'] ? api_models['Organization-organization_organization-read'].description : ''">Organization
                                    <ul>
                                        <li v-for="(ivalue, ikey) in api_models['Organization-organization_organization-read'].properties"  data-toggle="tooltip" :title="(ivalue.description ? ivalue.description : '')+' (Type: '+ivalue.type+')'" :data-val="'{'+'{ organization.'+ikey+' }}'" v-on:click.stop="insertOnPosition">{{ikey}}
                                            <ul v-if="ivalue.items">
                                                <li v-for="(iivalue, iikey) in api_models[ivalue.items['$ref'].substring(14)].properties"  data-toggle="tooltip" :title="(iivalue.description ? iivalue.description : '')+' (Type: '+iivalue.type+')'" :data-val="'{'+'{ organization.'+ikey+'['+value.locale+'].'+iikey+' }}'" v-on:click.stop="insertOnPosition">{{iikey}}</li>

                                            </ul>
                                        </li>
                                    </ul>

                                </li>
                                <li api-data-toggle="tooltip" title="Cookies Html" :data-val="'{'+'{ cookiesHtml|raw }}'" v-on:click.stop="insertOnPosition">Cookies Html</li>
                                <li api-data-toggle="tooltip" :title="api_models['Cookie-cookie_cookie-read'] ? api_models['Cookie-cookie_cookie-read'].description : ''">Cookies
                                    <ul>
                                        <li v-for="(ivalue, ikey) in api_models['Cookie-cookie_cookie-read'].properties"  data-toggle="tooltip" :title="(ivalue.description ? ivalue.description : '')+' (Type: '+ivalue.type+')'" :data-val="'{'+'{ cookies[...].'+ikey+' }}'" v-on:click.stop="insertOnPosition">{{ikey}}
                                            <ul v-if="ivalue.items">
                                                <li v-for="(iivalue, iikey) in api_models[ivalue.items['$ref'].substring(14)].properties"  data-toggle="tooltip" :title="(iivalue.description ? iivalue.description : '')+' (Type: '+iivalue.type+')'" :data-val="'{'+'{ cookies[...].'+ikey+'['+value.locale+'].'+iikey+' }}'" v-on:click.stop="insertOnPosition">{{iikey}}</li>

                                            </ul>
                                        </li>
                                    </ul>

                                </li>
                            </ul>
                        </div>

                        <span v-if="errors && errors.translations && errors.template" class="help-block"
                              :id="'_translation_'+ key +'_template_helplock'">{{ errors.translations[key].template }}</span>
                    </div>

                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
                        <label :for="'preview_button_'+item.translations[key].locale" class="control-label"> </label>
                        <button type="text" :id="'preview_button_'+item.translations[key].locale" class="btn btn-sm"  v-on:click.stop="previewDialog">Preview...</button>

                    </div>

                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.locale) }">
                        <input vmodel="item.translations[key].locale" type="hidden"
                               :id="'_translation_'+ key +'_locale'" class="form-control"/>
                        <input vmodel="item.translations[key].id" type="hidden" :id="'_translation_'+ key +'_id'"
                               class="form-control"/>
                        <span v-if="errors && errors.locale" class="help-block"
                              :id="'_translation_'+ key +'_locale_helpBlock'">{{ errors.locale }}</span>
                    </div>

                </div>
            </div>

        </div>

        <button type="submit" class="btn btn-primary">Submit</button>
    </form>
</template>
<style>
    .tree, .tree ul {
        margin:0;
        padding:0;
        list-style:none
    }
    .tree ul {
        margin-left:1em;
        position:relative
    }
    .tree ul ul {
        margin-left:.5em
    }
    .tree ul:before {
        content:"";
        display:block;
        width:0;
        position:absolute;
        top:0;
        bottom:0;
        left:0;
        border-left:1px solid
    }
    .tree li {
        margin:0;
        padding:0 1em;
        line-height:2em;
        color:#495057;

        position:relative
    }
    .tree ul li:before {
        content:"";
        display:block;
        width:10px;
        height:0;
        border-top:1px solid;
        margin-top:-1px;
        position:absolute;
        top:1em;
        left:0
    }
    .tree ul li:last-child:before {
        background:#fff;
        height:auto;
        top:1em;
        bottom:0
    }
    .indicator {
        margin-right:5px;
    }
    .tree li a {
        text-decoration: none;
        color:#369;
    }
    .tree li button, .tree li button:active, .tree li button:focus {
        text-decoration: none;
        color:#369;
        border:none;
        background:transparent;
        margin:0px 0px 0px 0px;
        padding:0px 0px 0px 0px;
        outline: 0;
    }
</style>

<script>
    import {API_LANGUAGES} from '../../config/languages';
    import { API_HOST, API_PATH } from '../../config/_entrypoint';
    import TreeView from "vue-json-tree-view"


    const API_URL = API_HOST+API_PATH;


    $.fn.extend({
        treed: function (o) {

            var openedClass = 'glyphicon-minus-sign';
            var closedClass = 'glyphicon-plus-sign';

            if (typeof o != 'undefined'){
                if (typeof o.openedClass != 'undefined'){
                    openedClass = o.openedClass;
                }
                if (typeof o.closedClass != 'undefined'){
                    closedClass = o.closedClass;
                }
            };

            //initialize each of the top levels
            var tree = $(this);
            tree.addClass("tree");
            tree.find('li').has("ul").each(function () {
                var branch = $(this); //li with children ul
                branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                branch.addClass('branch');
                branch.on('click', function (e) {
                    if (this == e.target) {
                        var icon = $(this).children('i:first');
                        icon.toggleClass(openedClass + " " + closedClass);
                        $(this).children().children().toggle();
                    }
                })
                branch.children().children().toggle();
            });
            //fire event from the dynamically added icon
            tree.find('.branch .indicator').each(function(){
                $(this).on('click', function () {
                    $(this).closest('li').click();
                });
            });
            //fire event to open branch if the li contains an anchor instead of text
            tree.find('.branch>a').each(function () {
                $(this).on('click', function (e) {
                    $(this).closest('li').click();
                    e.preventDefault();
                });
            });
            //fire event to open branch if the li contains a button instead of text
            tree.find('.branch>button').each(function () {
                $(this).on('click', function (e) {
                    $(this).closest('li').click();
                    e.preventDefault();
                });
            });
        }
    });

    export default {
        props: {
            handleSubmit: {
                type: Function,
                required: true,
            },
            values: {
                type: Object,
                required: true
            },
            errors: {
                type: Object
            },
            initialValues: {
                type: Object
            }
        },
        computed: {
            item: function () {

                let values = this.initialValues ? this.initialValues : this.values;
                let newtranslations = {};
                let translations = values.translations;
                Object.keys(API_LANGUAGES).map(function (objectKey, index) {
                    let value = API_LANGUAGES[objectKey];
                    let translation = {
                        "@id": null,
                        template: "",
                        locale: objectKey,
                    }
                    if (values.translations) {

                        for (let index in translations) {
                            let val = translations[index];
                            if (val.locale === objectKey) {
                                translation = val;
                            }
                        }
                    }
                    newtranslations[objectKey]=translation;
                });
                values.translations = newtranslations;
                fetch(API_URL+'docs.json', { method: 'GET'})
                    .then(response => response.json()).then(response => {
                        this.api_models= response.definitions;



                    $('.tree > ul').treed({openedClass : 'oi oi-plus', closedClass : 'oi oi-minus'});
                    //$('[data-toggle="tooltip"]').tooltip();
                });
                return values;
            }
        },
        methods:{
            insertOnPosition(event){

                if (!$(event.target).attr('data-val')) return;
                let field=$(event.target).closest('.tab-pane').find('textarea');
                let value= $(event.target).attr('data-val');

                let cursorPos = $(field).prop('selectionStart');
                let v = $(field).val();
                let textBefore = v.substring(0,  cursorPos);
                let textAfter  = v.substring(cursorPos, v.length);

                $(field).val(textBefore + value + textAfter);
            },
            previewDialog(event){

            }
        },
        data: function () {
            return {
                languages: API_LANGUAGES,
                api_models: {}
            }
        },
        components: {
            TreeView
        },
        created() {
            //console.log('created');

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/textblock/Form.vue